import React from 'react';
import { HStack, IconButton, Text } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

function Pagination({ currentPage, totalPages, onPageChange }) {
  return (
    <HStack spacing={4} justify="center" mt={6}>
      <IconButton
        aria-label="Previous page"
        icon={<ChevronLeftIcon />}
        isDisabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      />

      <Text fontWeight="medium">
        Page {currentPage} of {totalPages}
      </Text>

      <IconButton
        aria-label="Next page"
        icon={<ChevronRightIcon />}
        isDisabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      />
    </HStack>
  );
}

export default Pagination;
